const doc = [({"zh_cn":({"adminConstantHotelCheckInStatus":({"rejected":"拒绝", "requested":"已请求"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;